import { setupAxios } from '@carvana/core-auth';
import axios from 'axios';
import { defaults } from './axios';

export default setupAxios(axios.create(defaults), {
  addBearerTokenToAllRequests: true
});
